/**
 * Streams are needed by the subject form, the users filters and the
 * notification audience picker. One hook, one query, cached by Refine.
 */
import { useList } from '@refinedev/core'
import type { Stream } from '@/types'

export function useStreams() {
  const { data, isLoading } = useList<Stream>({
    resource: 'streams',
    pagination: { mode: 'off' },
    sorters: [{ field: 'sort_order', order: 'asc' }],
    filters: [{ field: 'is_active', operator: 'eq', value: true }],
  })

  return { streams: data?.data ?? [], isLoading }
}
